
import React from 'react';
import SessionRequestList from './SessionRequestList';
import { CalendarEvent } from '@/hooks/calendar/types';

interface SessionRequestsProps {
  onSessionStatusChange: () => void;
  onApproveRequest?: (eventId: string) => Promise<boolean>;
  onRejectRequest?: (eventId: string) => Promise<boolean>;
  onNavigateToClient?: (clientId: string) => void;
}

const SessionRequests: React.FC<SessionRequestsProps> = ({ 
  onSessionStatusChange,
  onApproveRequest,
  onRejectRequest,
  onNavigateToClient
}) => {
  return (
    <div className="animate-fade-in">
      <SessionRequestList 
        onSessionStatusChange={onSessionStatusChange} 
        onApproveRequest={onApproveRequest}
        onRejectRequest={onRejectRequest}
        onNavigateToClient={onNavigateToClient}
      />
    </div>
  );
};

export default SessionRequests;
